import { SET_UNAUTHENTICATED, MEMBER_LIST,
    LOADING_USER,
    INVOICE_LIST,
    LOADER_CHECK,
    } from '../type'

const initialState = {
//    invoiceData: {} 
    invoiceData: {
    data: [],
    loading: false,
    error: null,
  },   
}  


export default function (state = initialState, action) {
    switch (action.type) {
        case SET_UNAUTHENTICATED:
            return initialState;
        case INVOICE_LIST:
         
            // return {
            //     ...state,
            //     invoiceData: action.payload.data.date,
            //     loading: false
            // }
            return {
                ...state,
                invoiceData: {
                  ...state.invoiceData,
                  loading: false,
                //   data1: action.payload.date,
                  data: action.payload
                },
              };
        default:
            return state; 
    }
}
